import { corpusManifest, custodyLanes, manifestSummary } from "../knowledge/corpusManifest.js";
import { strategyLexicon } from "../knowledge/strategyLexicon.js";

export const sourceStatuses = custodyLanes;

export const corpusSources = corpusManifest.map((source) => ({
  id: source.id,
  title: source.title,
  tradition: source.tradition,
  status: source.lane,
  countable: source.lane === custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
  licenseBasis: source.licenseBasis,
  sourceUrl: source.sourceUrl,
  localFileHash: source.sha256,
  localPath: source.localPath,
  claimBoundary: source.blockedUses.join("; ")
}));

export const lexiconRegistry = [
  { pair: "high/low", class: "magnitude/rank", formula: "delta_y" },
  { pair: "more/less", class: "quantity", formula: "delta_q" },
  { pair: "strong/weak", class: "capability", formula: "ratio_c" },
  { pair: "open/closed", class: "gate", formula: "G in {0,1}" },
  { pair: "before/after", class: "temporal order", formula: "t1 < t2" },
  { pair: "inside/outside", class: "set boundary", formula: "x in S" },
  { pair: "visible/hidden", class: "observability", formula: "observed_x_vs_latent_z" },
  { pair: "advantage/disadvantage", class: "payoff", formula: "delta_U" },
  { pair: "order/disorder", class: "entropy", formula: "entropy_down_up" },
  { pair: "harmony/conflict", class: "stability", formula: "variance_down_up" },
  ...strategyLexicon.map((entry) => ({
    pair: `${entry.term}/${entry.aliases[0] ?? entry.variable}`,
    class: entry.class,
    formula: entry.math
  }))
];

export function corpusSummary() {
  return manifestSummary(corpusManifest);
}
